export const isTwoDaysEvent = (busySlot) => {
  return (
    busySlot.start.getDate() < busySlot.end.getDate() ||
    busySlot.start.getMonth() !== busySlot.end.getMonth()
  );
};
